export const ConfigData = [
  {
    id: "no",
    name: "iFeedback No.",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "matter",
    name: "Matter",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "created_by.name",
    name: "Created By",
    isShow: true,
    width: "160px",
    filter: false,
    format: "date",
  },
  {
    id: "created_on",
    name: "Created On",
    isShow: true,
    width: "160px",
    filter: false,
    // format: "date-time",
  },,
  {
    id: "updated_by.name",
    name: "Updated By",
    isShow: true,
    width: "160px",
    filter: false,
    // format: "date",
  },
  {
    id: "updated_on",
    name: "Updated On",
    isShow: true,
    width: "160px",
    filter: false,
    // format: "date-time",
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details", "Update Status","Delete"],
    permission: {
      ["View Details"]: {
        id: "View Details",
        permission: "ifeedback.limited_access_ifeedback_list",
      },
      ["Update Status"]: {
        id: "Update Status",
        permission: "ifeedback.limited_access_ifeedback_list",
      },
      Delete: {
        id: "Delete",
        permission: ["ifeedback.delete_ifeedback","ifeedback.limited_delete_ifeedback"],
      },
    },
    // isshowAction: {
    //   item: "status",
    //   children: [
    //     {
    //       id: "Publish",
    //       value: "Published",
    //       // notShowCondition: "Submitted",
    //     },
    //     {
    //       id: "Unpublish",
    //       value: "Unpublished",
    //       notShowCondition: "Submitted",
    //     },
    //   ],
    // },
  },
];
